<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">
        SMS Pro: L'Évolution de la Communication Personnalisée
      </h1>
      <h2 class="title center__text">Une solution marketing de haut niveau accessible à chacun</h2>
      
      <h2>Pourquoi envoyer des SMS pro ?</h2>
      <h2>1 - Emetteur personnalisé :</h2>
      <p>
        Optez pour la personnalisation de l'expéditeur du SMS Pro dans vos campagnes SMS pour une identification instantanée
        par vos destinataires. Modifiez le nom de l'expéditeur à chaque envoi, jusqu'à 11 caractères alphanumériques sur notre
        plateforme SMS.
      </p>
      <h2>2 - Accusés de réception :</h2>
      <p>
        Consultez en temps réel les statistiques de vos campagnes SMS professionnelles via votre espace client. Notre application
        pratique offre des informations détaillées, y compris la réception des SMS sur des téléphones allumés, injoignables ou invalides.
        Obtenez des réponses rapides sur les habitudes de vos utilisateurs avec un rapport téléchargeable en PDF.
      </p>
      
      <h2>3 - Envoi SMS international :</h2>
      <p>
        Bénéficiez d'une couverture mondiale avec la majorité des destinations incluses dans notre offre SMS Premium.
      </p>

      <h2>4 - Réception rapide du mailing SMS :</h2>
      <p>
        Le SMS Pro parvient habituellement en quelques secondes aux numéros de téléphone de vos destinataires,
        même lors d'envois massifs. Il représente une solution d'envoi de SMS rapide et de haute qualité.
      </p>
      <h2>5 - SMS Long :</h2>
      <p>
        Par défaut, un SMS professionnel est limité à 160 caractères, mais optez pour la solution SMS Long pour 
        transmettre des messages plus étendus à vos destinataires (chaque SMS sera décompté par tranche de 153 caractères
        supplémentaires).
      </p>
      <h2>6 - Personnalisation du contenu du SMS professionnel :</h2>
      <p>
        Personnalisez aisément votre SMS Pro en quelques clics en y ajoutant automatiquement un numéro de commande, une date, une heure de rendez-vous, ou même le prénom de votre interlocuteur. 
        Différenciez-vous avec des messages personnalisés au cours de vos campagnes SMS. 
      </p>
      <p>
        Notre service client SMS Pro offre des fonctionnalités étendues, vous procurant une liberté accrue dans votre communication par SMS pour chaque campagne.
      </p>
      <h2>Quels sont les avantages du SMS Pro ?</h2>
      
      <li><strong>Emetteur personnalisable</strong> : 11 caractères Alphanumériques à votre disposition<br/></li>
      <li><strong>Délivrabilité</strong>  : Vitesse d’envoi instantanée, taux de réception des SMS de 100%<br/></li>
      <li><strong>Lisibilité</strong> : taux d’ouverture et de lecture de + 98%<br/></li>
      <li><strong>Simplicité</strong> : envoyez vos campagnes avec notre plateforme intuitive ou connectez votre logiciel avec notre API<br/></li>
      <li><strong>Conversationnel</strong> : échangez avec vos contacts grâce au <strong>SMS Réponse</strong>  pour obtenir les informations qui vous
       intéressent pour améliorer votre Business.<br/></li>
       <li><strong>Statistiques</strong> : Suivi des accusés de réception pour une meilleure analyse de vos performances.<br/></li>
       <li><strong>Economie</strong>  : Economisez jusqu'à 60% sur votre budget de communication annuel. Consultez tous <strong><router-link to="/tarif">nos tarifs en ligne</router-link></strong>.</li>
      
    </section>
    <Footer/>
</div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

@media(min-width:64rem){
  .top__container{
  margin-top:10rem;
 }
}
</style>
